// extracted by mini-css-extract-plugin
export var container = "_mv-0";